module.exports = __webpack_public_path__ + "static/logo_small-1313bf43268ecec6f8bca3cc343936c4.png";